// src/index.js — BOND boot + HARD shim tegen negotiationneeded (zonder globalThis)
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./AuthContext";

// --- cross-env global reference (zonder globalThis) ---
const G =
  (typeof window !== "undefined" && window) ||
  (typeof global !== "undefined" && global) ||
  (function () {
    return this;
  })();

// ---- HARD SHIM: blokkeer ELKE poging om negotiationneeded te gebruiken ----
(function installBondShim() {
  if (G.__BOND_SHIM_INSTALLED__) return;
  G.__BOND_SHIM_INSTALLED__ = true;

  const proto = (G.RTCPeerConnection && G.RTCPeerConnection.prototype) || null;
  if (!proto) return;

  // 1) Blokkeer onnegotiationneeded=... setters
  try {
    const desc = Object.getOwnPropertyDescriptor(proto, "onnegotiationneeded");
    if (!desc || desc.configurable) {
      Object.defineProperty(proto, "onnegotiationneeded", {
        configurable: true,
        enumerable: true,
        get() {
          return null;
        },
        set(fn) {
          console.warn("[BOND SHIM] BLOCK onnegotiationneeded setter", fn);
        },
      });
    }
  } catch (e) {
    console.warn("[BOND SHIM] defineProperty onnegotiationneeded failed", e);
  }

  // 2) Blokkeer addEventListener("negotiationneeded", ...)
  try {
    const origAdd = proto.addEventListener;
    proto.addEventListener = function (type, listener, options) {
      if (String(type).toLowerCase() === "negotiationneeded") {
        console.warn(
          "[BOND SHIM] BLOCK addEventListener('negotiationneeded')",
          listener
        );
        return;
      }
      return origAdd.call(this, type, listener, options);
    };
  } catch (e) {
    console.warn("[BOND SHIM] patch addEventListener failed", e);
  }

  console.log("[BOND SHIM] negotiationneeded disabled globally");
})();

// ---- Mount app ----
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
